<template lang='pug'>
//- 抗癌金句
div(:class='$style[`cc-popbox-knowledge`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-popbox-knowledge-title`]')
    IconIdeas(:size='60')
    span.font-bold 抗癌
    span.font-bold.font-doctor-theme.no-wrap 金
    span.font-bold.font-normal-theme.no-wrap 句

  div(:class='$style[`cc-knowledge-wrap`]')
    div(v-if='randomContent' :class='$style[`cc-knowledge-wrap-block`]')
      span.font-medium(:class='$style[`cc-knowledge-wrap-block-title`]') {{ randomContent.content }}
    div(v-else :class='$style[`cc-knowledge-wrap-block`]')
      IconLoading(:size='30' :color='`#b1b1b1`')

    div(:class='$style[`cc-content-knowledge-controller`]')
      button.btn-extra.font-medium(
        aria-label='關閉'
        tabindex='0'
        :class='$style[`cc-knowledge-controller-btn`]'
        @click='handleClosePopBox') 關閉

      button.btn-extra.font-medium(
        aria-label='下一個'
        tabindex='0'
        :class='$style[`cc-knowledge-controller-btn`]'
        @click='handleClickShowNext') 看下一個

</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import IconIdeas from '../../icon/Ideas.vue';
import IconLoading from '../../icon/Loading';

import {
  putLoadGoldKnowLedge,
} from '../../../js/restapi';

export default {
  components: {
    IconIdeas,
    IconLoading,
  },

  created() {
    this.axiosLoadGoldKnowLedge();
  },

  data() {
    return {
      preloading: true,
      dataList: [],
      dataTotal: 0,
      nextTick: 1,
      // current: {
      //   content: '',
      //   category: ''
      // }
    };
  },

  methods: {
    ...mapMutations({
      changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
    }),

    axiosLoadGoldKnowLedge() {
      putLoadGoldKnowLedge('', {
        page: '1',
        size: '200',
        search: '',
      })
        .then((res) => {
          this.dataList = res.data.results;
          this.dataTotal = res.data.count;
          this.preloading = false;
        })
        .catch((err) => {});
    },

    handleClosePopBox() {
      this.changePopShowTutorialStatus({
        active: false,
        include: '',
      });
    },

    handleClickShowNext() {
      this.nextTick += 1;
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
    }),

    randomContent() {
      this.nextTick;
      const index = Math.floor(Math.random() * (this.dataTotal));
      const getContent = this.dataList[index];
      return getContent;
    },
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popGoldKnowledge.scss';
</style>
